import React from "react";

export default function MySQL_TAN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_TAN</h1>
      <p>This is the MySQL_TAN component generated from the SQL JSON.</p>
    </div>
  );
}
